import React from "react"
import {
  InputBase,
  inputSurfaceStyles,
  inputTypographyStyles
} from "../input-base"
import type { InputBaseProps } from "../input-base"
import { cn } from "../utils"

// =============================================================================
// Styles
// =============================================================================
const inputStyles = [
  "w-full min-w-0 px-3 py-2", // box
  inputSurfaceStyles,
  inputTypographyStyles,
  "aria-invalid:inset-ring-red-600", // invalid
  "disabled:cursor-not-allowed disabled:inset-ring-gray-200 disabled:text-gray-600" // disabled
]

// =============================================================================
// Props
// =============================================================================
export interface InputProps extends Omit<InputBaseProps, "className"> {
  /** Additional CSS classes for layout (width, margins) */
  className?: string
}

// =============================================================================
// Component
// =============================================================================
/**
 * A single-line text input.
 *
 * Renders the control on its own. Pair it with a `Field` to give it a label:
 *
 * @example
 * ```tsx
 * <Field>
 *   <Field.Label>Reply-to address</Field.Label>
 *   <Input
 *     type="email"
 *     value={value}
 *     onValueChange={setValue}
 *     invalid={Boolean(error)}
 *   />
 * </Field>
 * ```
 */
export const Input = React.forwardRef<HTMLInputElement, InputProps>(
  function Input({ className, ...props }, ref) {
    return (
      <InputBase {...props} ref={ref} className={cn(inputStyles, className)} />
    )
  }
)

Input.displayName = "Input"

export type { InputType, InputChangeEventDetails } from "../input-base"
